import { render, staticRenderFns } from "./PersonsEdit.vue?vue&type=template&id=5c7658dc"
import script from "./PersonsEdit.vue?vue&type=script&lang=js"
export * from "./PersonsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports